<!--
  Grouped order artifact (WB-7598) — the orders one create-order run produced.

  Shares the `.order-artifact` class family with the single-order card on
  purpose: same shell, header rhythm, table and footer. Only the table's subject
  differs (orders here, line items there).
-->
<div
    class="order-artifact order-group-artifact"
    [class.order-group-artifact--no-pricing]="hidePricing"
    *ngIf="group">
    <div class="order-artifact__header">
        <!-- Split icon rather than the cart: the point of this card is that one
             run produced several orders. -->
        <span class="order-artifact__icon">
            <ui-svg-icon svgIcon="split" size="medium"></ui-svg-icon>
        </span>
        <div class="order-artifact__header-main">
            <div class="order-artifact__title-row">
                <span class="order-artifact__title">
                    {{ 'smart_inbox.order_group_artifact.title' | translate: { count: orderCount } }}
                </span>
            </div>
        </div>
        <span class="order-artifact__last-modified" *ngIf="lastModifiedAt">
            {{ 'smart_inbox.order_artifact.last_modified' | translate }}
            {{ lastModifiedAt | daysAgoOrLeft: 'ago' : 2 : 'DD/MM/YYYY HH:mm' }}
        </span>
    </div>

    <table class="order-artifact__table">
        <thead>
            <tr>
                <th class="order-group-artifact__col-reference">{{ 'smart_inbox.order_group_artifact.columns.order_id' | translate }}</th>
                <th class="order-group-artifact__col-customer">{{ 'smart_inbox.order_group_artifact.columns.customer' | translate }}</th>
                <th class="order-group-artifact__col-status">{{ 'smart_inbox.order_group_artifact.columns.status' | translate }}</th>
                <th class="order-group-artifact__col-amount" *ngIf="!hidePricing">{{ 'smart_inbox.order_group_artifact.columns.amount' | translate }}</th>
                <!-- Holds the split-reason icon. Unlabelled: the icon explains itself
                     on hover, and a header here would name a column most rows leave empty. -->
                <th class="order-group-artifact__col-info"></th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="let row of rows; trackBy: trackByRow"
                class="order-artifact__row"
                (click)="onOpenOrder(row, $event)">
                <td class="order-group-artifact__col-reference">{{ row.reference }}</td>

                <td class="order-group-artifact__col-customer">
                    <span *ngIf="!row.isCustomerMissing" [matTooltip]="row.customerName" matTooltipClass="conversation-tooltip-info">
                        {{ row.customerName }}
                    </span>
                    <span
                        class="order-group-artifact__missing-customer"
                        *ngIf="row.isCustomerMissing"
                        [matTooltip]="'smart_inbox.order_artifact.missing_customer_tooltip' | translate"
                        matTooltipClass="conversation-tooltip-info">
                        {{ 'smart_inbox.order_artifact.missing_customer' | translate }}
                    </span>
                </td>

                <td class="order-group-artifact__col-status">
                    <!-- Per-order chip: statuses can legitimately differ across the run. -->
                    <span class="order-artifact__status" [ngStyle]="row.statusStyles">
                        {{ 'quotations_and_orders.QuotationStatus.' + row.status | translate }}
                    </span>
                </td>

                <td class="order-group-artifact__col-amount" *ngIf="!hidePricing">
                    <ng-container *ngIf="row.allLinesNoPrice; else rowAmount">
                        {{ 'quotations_and_orders.price_source_none' | translate }}
                    </ng-container>
                    <!-- Null check, not truthiness: a free order totals 0, it is not unpriced. -->
                    <ng-template #rowAmount>
                        {{ row.amount != null ? (row.amount | number: '1.2-2') + ' ' + row.currencySymbol : '--' }}
                    </ng-template>
                </td>

                <td class="order-group-artifact__col-info">
                    <!-- Only on orders a segregation rule split off; an AI multi-order
                         PDF split carries no provenance to explain. -->
                    <ui-svg-icon
                        *ngIf="row.splitReason as reason"
                        class="order-group-artifact__info-icon"
                        svgIcon="info-icon"
                        size="small"
                        [matTooltip]="reason"
                        matTooltipClass="conversation-tooltip-info"></ui-svg-icon>
                </td>
            </tr>
        </tbody>
    </table>

    <!-- Group total. Dropped entirely when pricing is hidden, so the strip is not
         left as an empty banded row (same rule as the single card, WB-7569), and
         when the run spans two currencies — the rows each say which one they are
         in, a single summed figure could not. -->
    <div class="order-artifact__summary" *ngIf="!hidePricing && !mixedCurrency">
        <span class="order-artifact__summary-spacer"></span>
        <span class="order-artifact__total">
            <ng-container *ngIf="allNoPrice; else totalValue">
                {{ 'quotations_and_orders.price_source_none' | translate }}
            </ng-container>
            <ng-template #totalValue>{{ currencyCode }} {{ total | number: '1.2-2' }}</ng-template>
        </span>
    </div>
</div>
